export const setDefaultDocumentName = () => {
  if (process.env.REACT_APP_IS_CLIC === '0') {
    document.title = 'QR Menu'
  }
  if (process.env.REACT_APP_IS_CLIC === '1') {
    document.title = 'Click & Collect'
  }
}
